import { LoaderFunctionArgs, redirect } from "react-router-dom";

import { myAxios, MyDate } from "src/components/common/functions";
import type { MapAssignment, MapWorkRow } from "./types";

export async function mapsLoader({ request }: LoaderFunctionArgs) {
    const url = new URL(request.url);
    const selectedDate = url.searchParams.get("selectedDate");
    if (!selectedDate) {
        url.searchParams.set("selectedDate", new MyDate().s().slice(0, 10));
        throw redirect(url.pathname + "?" + url.searchParams.toString());
    }

    const formData = new FormData();
    formData.append("selectedDate", selectedDate);
    const res = await myAxios({ fileName: "maps/readWorks.php", formData });
    if (!res) throw redirect("..");
    const works = (res.data ?? []).map((work: MapWorkRow) => ({
        ...work,
        assignments: (work.assignments ?? []).map((assignment: MapAssignment) => ({
            ...assignment,
            workId: assignment.workId || work.workId,
        })),
    }));
    return { selectedDate, works };
}
